<template>
    <div class="Information">
        <div class="row">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-4">
                        <div class="record-section">
                            <h4>Enrollment Information:</h4>
                            <p>
                                <span class="bold">Program Name: </span> {{ RecordData.SubProgramMemberships[0].SubProgram.Name }}
                            </p>
                            <p>
                                <span class="bold">Relationship Start Date: </span>
                                <DateEditor v-bind:old-value="RecordData.SubProgramMemberships[0].StartDate"
                                                   v-bind:record-id="RecordData.SubProgramMemberships[0].Id"
                                                   v-bind:edit-mode="EditMode"
                                                   data-label="Relationship Start Date"
                                                   property-name="SubProgramStartDate"
                                                   update-method="StrongFamilies/Churches"
                                                   required="true"
                                                   warning-notice="Modifying the start date may affect other records, and reports that have already been generated should be updated."
                                                   :global-update="true"
                                                   :chart-id="RecordData.Id"
                                                   edit-permission="StrongFamiliesModuleGeneral" 
                                                   http-method="PATCH"/>
                            </p>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col col-md-12">
                <div class="record-section">
                    <h4>Church Relationship Status History:</h4>
                    <StatusEditor           :global-update="true"
                                           :chart-id="RecordData.Id"
                                           :edit-mode="EditMode" />
                </div>
            </div>
        </div>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import DateEditor from '../../../../Core/ItemEditors/DateEditor.vue';
    import DateEditorRequest from '../../../../Core/ItemEditors/DateEditorRequest.vue';
    import StringEditor from '../../../../Core/ItemEditors/StringEditor.vue';
    import IntegerEditor from '../../../../Core/ItemEditors/IntegerEditor.vue';
    import SelectEditor from '../../../../Core/ItemEditors/SelectEditor.vue';
    import SelectEditorRequest from '../../../../Core/ItemEditors/SelectEditorRequest.vue';
    import StatusEditor from './StatusEditor.vue';
    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';

    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                Agencies: [],
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
        },
        components: {
            DateEditor,
            DateEditorRequest,
            StringEditor,
            IntegerEditor,
            SelectEditorRequest,
            EditMode,
            SelectEditor,
            StatusEditor
        },
        mounted() {

        },
        computed: {

        }
    }
</script>

<style scoped>
</style>